export default {
  app: true,
  clubsite: true,
  store: true,
  memberships: true,
  rewards: true,
  ticketing: true,
  clubtv: true,
  clickcollect: true,
  auctionsite: true
}
